<template>
    <div class="calcform">
        <div class="container">
            <h2>Alat za procjenu rada fotonaponskog sustava</h2>

            <!--<div class="obavezno">* Svi podaci su obavezni</div>-->

            <div class="tekst">
                <div class="buttonWrap">
                    <button class="accordion border-1" type="button" @click="
            (ev) => {
              ev.currentTarget.classList.toggle('active');
            }
          ">
                        O čemu se tu zapravo radi?
                    </button>
                    <div class="panel">
                        <p>
                            Alat za procjenu rada fotonaponskog sustava s energetskog stajališta omogućit će
                            potencijalnim investitorima sagledavanje šireg aspekta poslovnog poduhvata te dati
                            informaciju o razmatranom projektu uzevši u obzir podatke za konkretnu lokaciju i korištenje
                            sustava. U alat će biti ugrađeno iskustvo tvrtke OM Projekt stečeno na projektima u
                            području
                            obnovljivih izvora energije, a omogućit će informiranje i educiranje potencijalnih
                            investitora o parametrima bitnim za procjenu rada fotonaponskog sustava, kao i pružiti
                            tehničku potporu prilikom donošenja poslovne odluke. Alat će biti osnova razvoja daljnjih
                            rješenja u području obnovljivih izvora energije.
                        </p>
                        <p>
                            Svrha predmetnog projekta je formalizirati znanje i iskustvo koje postoji u akademskoj
                            zajednici u oblik koji će omogućiti izradu matematičkog modela alata za procjenu rada
                            fotonaponskog sustava, temeljem niza varijabli vezanih za konkretnu lokaciju i objekt,
                            odnosno dosadašnjeg iskustva tvrtke OM Projekt te time pružiti potporu potencijalnom
                            investitoru prilikom donošenja odluke o investiciji, odnosno predstavljat će podlogu za
                            razvoj slijednih aplikacija u području OIE, što će u sklopu energetske tranzicije ka
                            niskougljičnom društvu u razdoblju koje slijedi imati sve veću ulogu prilikom procesa
                            dekarbonizacije.
                        </p>
                    </div>
                </div>
            </div>

            <form @submit.prevent="validate">
                <ul class="flex-outer">
                    <li><h4>Osnovne informacije</h4></li>
                    <li>
                        <label for="iskoristivaPovrsinaKrova">
                            Iskoristiva površina krova [m<sup>2</sup>]
                        </label>
                        <input type="number" class="form-control" id="iskoristivaPovrsinaKrova" min="0"
                               v-model.number="iskoristivaPovKrova" placeholder="60" required/>
                    </li>
                    <li>
                        <label for="godPotrosnjaKucanstva">
                            Godišnja potrošnja električne energije [kWh/god]
                        </label>
                        <input type="number" class="form-control" id="godPotrosnjaKucanstva" min="0"
                               v-model.number="godPotrosnja" placeholder="8000" required/>
                    </li>
                    <li>
                        <label for="godSmanjenjePotrosnje">
                            Planirano godišnje smanjenje potrošnje el. energije [%]
                        </label>
                        <input type="number" class="form-control" id="godSmanjenjePotrosnje" min="0"
                               v-model.number="godSmanjenjePotrosnje" placeholder="3" required/>
                    </li>
                    <li>
                        <label for="udioFNE">
                            Udio FNE u ukupnoj potrošnji kućanstva [%]
                        </label>
                        <input type="number" class="form-control" id="udioFNE" min="0" v-model.number="udioFNE"
                               placeholder="50" required/>
                    </li>
                    <li>
                        <label for="zakSnagaObjekta">
                            Zakupljena snaga objekta [kW]
                        </label>
                        <input type="number" class="form-control" id="zakSnagaObjekta" min="0"
                               v-model.number="zakSnagaObjekta" placeholder="8" required/>
                    </li>

                    <li><h4>Dodatni potrošači (dnevna potrošnja)</h4></li>
                    <li>
                        <label for="elAuto">
                            Električni automobil [kWh]
                        </label>
                        <input type="number" class="form-control" id="elAuto" min="0" v-model.number="elAuto"
                               placeholder="1500" required/>
                    </li>
                    <li>
                        <label for="elBicikla">
                            Električna bicikla [kWh]
                        </label>
                        <input type="number" class="form-control" id="elBicikla" min="0" v-model.number="elBicikla"
                               placeholder="500" required/>
                    </li>
                    <li><h4>Financiranje projekta</h4></li>
                    <li class="centered-li">
                        <label>Planirate li se javiti na javni poziv FZOEU za sufinanciranje?
                            <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip">
                                    Fond će Korisnicima dodjeljivati sredstva donacije do 75.000,00 kuna po prijavi, za opravdane troškove nabave i ugradnje jedne nove FNE (s PDV-om): <br>
                                    - do 80%, ali ne više od 75.000,00 kn na području posebne državne skrbi i na prvoj skupini otoka, <br>
                                    - do 60%, ali ne više od 56.250,00 kn na brdsko-planinskom području i na drugoj skupini otoka, <br>
                                    - do 40%, ali ne više od 37.500,00 kn na ostalim područjima RH <br>
                                    Raspoloživa sredstva Fonda po Pozivu iznose 10.000.000,00 kn
                                </div>
                            </span>
                            </div>
                        </label>

                        <div>
                            <input type="radio" id="FZOEUda" name="FZOEU" v-model="FZOEU" value="true">
                            <label for="FZOEUda">Da</label>
                            <input type="radio" id="FZOEUne" name="FZOEU" v-model="FZOEU" value="false">
                            <label for="FZOEUne">Ne</label>
                        </div>
                    </li>
                    <li v-if="FZOEU === 'true'">
                        <label for="razinaSub">
                            Odabir razine subvencije
                        </label>
                        <select class="form-control" id="razinaSub" v-model="odabranaSub" required>
                            <option v-for="item in subvencijaOpcije" :key="item.id" :value="item.id">{{ item.name }}
                            </option>
                        </select>
                    </li>
                    <li v-if="FZOEU === 'true'">
                        <label for="iznosSub">
                            Planirani iznos subvencije (kn)
                        </label>
                        <currency-input id="iznosSub" v-model.number="subvencija" disabled/>
                    </li>
                    <li v-if="FZOEU === 'true'">
                        <label for="ostatak">
                            Preostali troškovi
                        </label>
                        <currency-input id="ostatak" v-model="pocetno_ulaganje_bruto_bez_stip" disabled/>
                    </li>
                    <li>
                        <label for="planiraniKredit">Planirani iznos kredita (kn)</label>
                        <currency-input class="form-control" id="planiraniKredit" placeholder="10000"
                                        :value-range="{ min: 0 }" v-model="iznos_kredita" required/>
                    </li>
                    <li v-if="kredit === true" class="errors">
                        <span>*{{ kreditText }}</span>
                    </li>
                    <li>
                        <label for="kamatnaStopa">Kamatna stopa (%)</label>
                        <input type="number" class="form-control" step="0.1" id="kamatnaStopa" placeholder="4" min="0"
                               v-model.number="kam_stopa" required/>
                    </li>
                    <li>
                        <label for="rokOtplate">
                            Rok otplate [godina]
                            <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip"><p>Maksimalno razdoblje - 15 godina</p></div>
                            </span>
                            </div>
                        </label>
                        <input type="number" class="form-control" id="rokOtplate" placeholder="5" min="0" max="15"
                               v-model.number="rok_otplate" required/>
                    </li>
                    <li>
                        <label for="amortRazdoblje">
                            Amortizacijsko razdoblje [godina]
                            <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip"><p>Maksimalno razdoblje - 15 godina</p></div>
                            </span>
                            </div>
                        </label>
                        <input type="number" class="form-control" id="amortRazdoblje" placeholder="10" min="0" max="15"
                               v-model="amort_razd" required/>
                    </li>
                    <li>
                        <button type="submit">Izračunaj</button>
                    </li>
                </ul>
            </form>
        </div>
        <div class="rezultat" v-if="doneCalculate===true && kredit ===false && error === false">
            <div class="vrijednosti">
                <h2>Proračun</h2>
                <h4>Provjera uvjeta površine krova</h4>
                <table>
                    <thead>
                    <tr>
                        <th>Atribut</th>
                        <th>Vrijednost</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Postojeća površina krova</td>
                        <td>{{ iskoristivaPovKrova }} m<sup>2</sup></td>
                    </tr>
                    <tr>
                        <td>Potrebna površina krova</td>
                        <td>{{ (potrebnaPovKrova).toFixed(2) }} m<sup>2</sup></td>
                    </tr>
                    <tr>
                        <td>Faktor iskoristivosti</td>
                        <td>{{ faktor_iskoristivosti }}</td>
                    </tr>
                    <tr>
                        <td>Mogućna snaga FNE</td>
                        <td>{{ mogucna_snaga_FNE }} kW</td>
                    </tr>
                    </tbody>
                </table>
                <h4>Izračun snage FNE</h4>
                <table>
                    <thead>
                    <tr>
                        <th>Atribut</th>
                        <th>Vrijednost</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Prosječna godišnja potrošnja</td>
                        <td>{{ godPotrosnja }} kWh</td>
                    </tr>
                    <tr>
                        <td>Smanjenje potrošnje</td>
                        <td>{{ smanjenjePotrosnje }}</td>
                    </tr>
                    <tr>
                        <td>Dodatni potrošači</td>
                        <td>{{ elBicikla + elAuto }} kWh</td>
                    </tr>
                    <tr>
                        <td>Očekivana godišnja proizvodnja</td>
                        <td>1000 kWh/kW</td>
                    </tr>
                    <tr>
                        <td>Faktor proizvodnje</td>
                        <td>{{ faktor_proizvodnje }}</td>
                    </tr>
                    <tr>
                        <td>Izračunata snaga FNE</td>
                        <td>{{ (snaga_FNE).toFixed(2) }} kW</td>
                    </tr>
                    <tr>
                        <td>Planirana godišnja proizvodnja</td>
                        <td>{{ Math.round(plan_god_pro) }} kWh</td>
                    </tr>
                    <tr>
                        <td>Potrebna površina krova</td>
                        <td>{{ (potrebnaPovKrova).toFixed(2) }} m<sup>2</sup></td>
                    </tr>
                    <tr>
                        <td>Uvjet krova</td>
                        <td>{{ krovText }}</td>
                    </tr>
                    <tr>
                        <td>Uvjet priključne snage</td>
                        <td>{{ snagaText }}</td>
                    </tr>
                    <tr v-if="potreban_dokup_snage">
                        <td>Potreban dokup snage</td>
                        <td>{{ (potreban_dokup_snage).toFixed(2) }} kW</td>
                    </tr>
                    </tbody>
                </table>

                <div class="dobit">
                    <h4>Ukupno početno ulaganje u projekt</h4>
                    <table>
                        <thead>
                        <tr>
                            <th>Atribut</th>
                            <th>Vrijednost</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Oprema</td>
                            <td>{{ cijena_oprema | toCurrency }}</td>
                        </tr>
                        <tr v-if="cijena_dokup">
                            <td>Dokup snage od HEP-a</td>
                            <td>{{ cijena_dokup  | toCurrency }}</td>
                        </tr>
                        <tr>
                            <td>Izrada projektne dokumentacije</td>
                            <td>{{ cijena_dokumentacije  | toCurrency }}</td>
                        </tr>
                        <tr>
                            <td>Ostalo (ispitivanje instalacije sekundara od ovlaštenog električara)</td>
                            <td>{{ cijena_ostalo  | toCurrency }}</td>
                        </tr>
                        <tr class="border-top">
                            <td>Ukupno neto</td>
                            <td>
                                {{ pocetno_ulaganje | toCurrency }}
                            </td>
                        </tr>
                        <tr>
                            <td>PDV:</td>
                            <td>
                                +{{ pocetno_ulaganje | toCurrency }}
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td class="total" colspan="2">
                                Ukupno bruto:
                                <span class="space">{{ pocetno_ulaganje_bruto | toCurrency }}</span>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="dobit">
                    <h4>Omjer financiranja</h4>
                    <table>
                        <thead>
                        <tr>
                            <th>Opis</th>
                            <th>Iznos</th>
                            <th>%</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Kredit banke</td>
                            <td>{{ iznos_kredita | toCurrency }}</td>
                            <td>{{ ((iznos_kredita / (pocetno_ulaganje_bruto)) * 100).toFixed(2) }} %</td>
                        </tr>
                        <tr>
                            <td>Vlastita sredstva /subvencija</td>
                            <td>{{ pocetno_ulaganje_bruto - iznos_kredita | toCurrency }}</td>
                            <td>{{
                                    (((pocetno_ulaganje_bruto - iznos_kredita) / ((pocetno_ulaganje_bruto))) * 100).toFixed(2)
                                }} %
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="dobit">
                    <h4>Povrat investicije (kumulativ)</h4>
                    <table>
                        <thead>
                        <tr>
                            <th>Godina</th>
                            <th>Vrijednost</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="povrat in povratInvesticije" :key="povrat.id">
                            <td>{{ povrat.id }}</td>
                            <td>{{ (povrat.povrat).toFixed(2) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          <!--  <div class="dobit">
                 <h2>Ukupna godišnja potrošnja</h2>
                 <column-chart xtitle="Godine" ytitle="Iznos" :data="ukupna_god_potrosnja_graf" :colors="['#f0ad4e', ]"
                               height="500px"
                               :stacked="false"></column-chart>
             </div>
            <div class="dobit">
                <h2>ROA
                    <div class="box">
                    <span>
                        <span class="material-icons">help</span>
                       <div class="tooltip">eng. Return On Assets - predstavlja povrat od uložene imovine, pokazatelj rentabilnosti odnosno profitabilnosti imovine</div>
                    </span>
                    </div>
                </h2>
                <column-chart xtitle="Godine" ytitle="Postotak" :data="roa" :colors="['#f0ad4e', ]" height="500px"
                              :stacked="false" :discrete="false" suffix="%"></column-chart>
            </div>-->

            <div class="centerButton">
                <button @click="clearForm" class="clearButton">Očisti</button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    data() {
        return {
            iskoristivaPovKrova: null,
            zakSnagaObjekta: null,
            godSmanjenjePotrosnje: null,
            udioFNE: null,
            godPotrosnja: null,

            elAuto: null,
            elBicikla: null,

            FZOEU: null,
            subvencijaOpcije: [{
                id: 1,
                name: 'Do 80%, ali ne više od 75.000,00 kn'
            },
                {
                    id: 2,
                    name: 'Do 60%, ali ne više od 56.250,00 kn'
                },
                {
                    id: 3,
                    name: 'Do 40%, ali ne više od 37.500,00 kn'
                },
            ],
            odabranaSub: null,
            subvencija: 0,
            iznos_kredita: null,
            kam_stopa: null,
            rok_otplate: null,
            amort_razd: null,

            //vrijednosti provjera povrsine krova
            potrebnaPovPokW: 6,
            faktor_iskoristivosti: 0.9,
            mogucna_snaga_FNE: null,

            //izracun snage FNE
            smanjenjePotrosnje: null,
            ocek_god_pot: 1000,
            faktor_proizvodnje: 0.9,
            snaga_FNE: null,
            plan_god_pro: null,
            potrebnaPovKrova: null,
            potreban_dokup_snage: 0,

            //početno ulaganje
            cijena_oprema_help: 6480,
            cijena_dokup_help: 1350,
            cijena_dokumentacije: 5000,
            cijena_ostalo: 2500,
            cijena_oprema: null,
            cijena_dokup: null,
            pocetno_ulaganje: null,
            pocetno_ulag_PDV: null,
            pocetno_ulaganje_bruto: null,
            pocetno_ulaganje_bruto_bez_stip: 0,
            god_amortizacija: null,

            //izvori financiranja i kredit
            anuitet: 0,
            iznos_kamate_god: [],
            iznos_kvota: [],
            ostatak_duga: [],

            //ekonomski i novčani tok
            ukupna_god_potrosnja: [],
            ukupna_god_potrosnja_graf: [],
            planirana_god_potrosnja: null,
            cijena_otkupa: 0.9727,
            troskoviOpskrbNeto: [],
            troskoviOpskrbBruto: [],
            prihodFNE_god_usteda: [],
            razlikaZaNaplatu: [],
            odrzavanje: 300,
            fin_rashodi: [],
            umanjena_god_usteda: [],
            umanjena_god_usteda_PDV: [],
            umanjena_god_usteda_bruto: [],

            ekonomicnost: [],
            EBIT: [],
            EBITDA: [],
            brutoProfMrez: [],
            netoProfMrez: [],
            ulaganje_imovina: [],
            dug: [],
            roa: [],
            povrat: [],
            nnt: [],
            dostatnostNNT: [],
            /*AAR: null,
            AARR: null,
            NPV: null,*/
            povratInvesticije: [],

            doneCalculate: false,

            error: false,
            errorText: "Maksimalni iznos subvencije iznosi 91.250,00 kn ili 60 % investicije bez PDV-a",

            snagaText: "",
            krovText: "",

            kredit: false,
            kreditText: "Kredit je veći od iznosa koji se treba platiti",

            subvencija_postotak: null,
        };
    },

    methods: {
        pocetniTroskovi() {
            //provjera površine krova
            this.mogucna_snaga_FNE = (this.iskoristivaPovKrova / this.potrebnaPovPokW) * this.faktor_iskoristivosti;

            //izračun snage FNE
            this.smanjenjePotrosnje = 1 - (this.godSmanjenjePotrosnje / 100);
            this.snaga_FNE = (((this.godPotrosnja + this.elAuto + this.elBicikla) * this.smanjenjePotrosnje) * (this.udioFNE / 100)) / (this.ocek_god_pot * this.faktor_proizvodnje);
            this.plan_god_pro = this.snaga_FNE * this.ocek_god_pot * this.faktor_proizvodnje;
            this.potrebnaPovKrova = this.snaga_FNE * this.potrebnaPovPokW;
            if (this.snaga_FNE > this.zakSnagaObjekta) {
                this.snagaText = "POTREBAN DOKUP SNAGE";
                this.potreban_dokup_snage = this.snaga_FNE - this.zakSnagaObjekta;
            } else {
                this.snagaText = "SNAGA FNE UNUTAR GRANICA";
            }
            if (this.potrebnaPovKrova < this.iskoristivaPovKrova) {
                this.krovText = "POVRŠINA KROVA ZADOVOLJAVA";
            } else {
                this.krovText = "POVRŠINA KROVA NE ZADOVOLJAVA";
            }

            //početno ulaganje
            this.cijena_oprema = this.cijena_oprema_help * this.snaga_FNE;
            if (this.potreban_dokup_snage !== null) {
                this.cijena_dokup = this.cijena_dokup_help * this.potreban_dokup_snage;
                this.pocetno_ulaganje = (this.cijena_oprema + this.cijena_dokup + this.cijena_dokumentacije + this.cijena_ostalo);
            } else {
                this.pocetno_ulaganje = (this.cijena_oprema + this.cijena_dokumentacije + this.cijena_ostalo);
            }

            this.pocetno_ulag_PDV = this.pocetno_ulaganje * 0.25;
            this.pocetno_ulaganje_bruto = this.pocetno_ulaganje + this.pocetno_ulag_PDV;

        },
        subvencijaIzracun() {
            if (this.odabranaSub === 1) {
                this.subvencija = this.pocetno_ulaganje * 0.8;
                if (this.subvencija > 75000) {
                    this.subvencija = 75000;
                }
            } else if (this.odabranaSub === 2) {
                this.subvencija = this.pocetno_ulaganje * 0.6;
                if (this.subvencija > 56250) {
                    this.subvencija = 56250;
                }
            } else if (this.odabranaSub === 3) {
                this.subvencija = this.pocetno_ulaganje * 0.4;
                if (this.subvencija > 37500) {
                    this.subvencija = 37500;
                }
            }
            //provjera kredita

            this.pocetno_ulaganje_bruto_bez_stip = this.pocetno_ulaganje + this.pocetno_ulaganje * 0.25 - this.subvencija;

            if (this.iznos_kredita > this.pocetno_ulaganje_bruto_bez_stip) {
                this.kredit = true;
            } else {
                this.kredit = false;
            }


        },

        validate() {
            this.pocetniTroskovi();
            this.subvencijaIzracun();
            if (this.error === false && this.kredit === false && this.doneCalculate === false) {
                this.calculate();
            }
        },

        calculate() {
            this.god_amortizacija = (this.pocetno_ulaganje - this.subvencija) / this.amort_razd;

            //Izvor financiranja i kredit
            let iznos = this.iznos_kredita;
            this.anuitet = this.PMT(((this.kam_stopa / 100)), this.rok_otplate, this.iznos_kredita);

            for (let i = 0; i < 15; i++) {
                if (i < this.rok_otplate) {
                    this.iznos_kamate_god.push((iznos * (this.kam_stopa / 100)));
                    this.iznos_kvota.push(this.anuitet - this.iznos_kamate_god[i])
                    if (i === 0) {
                        this.ostatak_duga.push(this.kredit - this.iznos_kvota[i])
                    } else {
                        this.ostatak_duga.push(this.ostatak_duga[i - 1] - this.iznos_kvota[i])
                    }
                    iznos = iznos - this.anuitet + this.iznos_kamate_god[i];
                } else {
                    this.iznos_kamate_god.push(0);
                    this.iznos_kvota.push(0);
                    this.ostatak_duga.push(0);
                }
            }

            //ekonomski i financijski tok
            this.prihodFNE_god_usteda = this.plan_god_pro * this.cijena_otkupa;

            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.ukupna_god_potrosnja.push((this.godPotrosnja + this.elAuto + this.elBicikla) * (1 - (this.godSmanjenjePotrosnje / 100)));
                } else {
                    this.ukupna_god_potrosnja.push(this.ukupna_god_potrosnja[i - 1] * (1 - (this.godSmanjenjePotrosnje / 100)));
                }

                this.troskoviOpskrbNeto.push(this.ukupna_god_potrosnja[i] * this.cijena_otkupa);
                this.troskoviOpskrbBruto.push(this.troskoviOpskrbNeto[i] * 1.25);

                this.razlikaZaNaplatu = this.troskoviOpskrbNeto[i] - this.prihodFNE_god_usteda;

                this.fin_rashodi = this.odrzavanje + this.god_amortizacija + this.iznos_kamate_god[i] + this.troskoviOpskrbNeto[i];

                this.umanjena_god_usteda.push(this.prihodFNE_god_usteda - (this.odrzavanje + this.god_amortizacija + this.iznos_kamate_god[i]));
                this.umanjena_god_usteda_PDV.push(this.umanjena_god_usteda[i] * 0.25);
                this.umanjena_god_usteda_bruto.push(this.umanjena_god_usteda + this.umanjena_god_usteda_PDV);
            }

            for (let i = 0; i < 15; i++) {
                this.ekonomicnost.push(this.prihodFNE_god_usteda / this.fin_rashodi[i]);
                this.EBIT.push(this.iznos_kamate_god[i] + this.umanjena_god_usteda_bruto);
                this.EBITDA.push(this.god_amortizacija + this.EBIT[i]);

                this.brutoProfMrez.push(this.umanjena_god_usteda_bruto / this.prihodFNE_god_usteda);
                this.netoProfMrez.push(this.umanjena_god_usteda / this.prihodFNE_god_usteda);

                if (i === 0) {
                    this.ulaganje_imovina.push(this.pocetno_ulaganje - this.god_amortizacija);
                } else {
                    this.ulaganje_imovina.push(this.ulaganje_imovina[i - 1] - this.god_amortizacija);
                }

                this.nnt.push(this.god_amortizacija + this.iznos_kamate_god[i] + this.umanjena_god_usteda);
                this.dostatnostNNT.push(this.nnt[i] - this.anuitet);

            }

            this.doneCalculate = !this.doneCalculate;

            this.calculatePovratByYear();
            this.calcuateSumPot();
            this.calculateRoaByYear();

            Vue.nextTick(() => {
                this.scrollToElement();
            })

        },

        scrollToElement() {
            const el = this.$el.getElementsByClassName('rezultat')[0];

            if (el) {
                el.scrollIntoView();
            }
        },

        PMT: function (kamata, broj_uplata, pocetni_iznos) {

            let eksponent = Math.pow(1 + kamata, broj_uplata);
            let pmt = -(kamata / (eksponent - 1) * -(pocetni_iznos * eksponent + 0)); // nula je tu jer inače ide future value koji označuje na kolikom iznosu želimo biti nakon navedenog razdoblja, a to je 0

            return pmt;
        },

        calculatePovratByYear() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.povratInvesticije.push({
                        id: i + 1,
                        povrat: (this.umanjena_god_usteda[i] - this.pocetno_ulaganje)
                    });
                } else {
                    this.povratInvesticije.push({
                        id: i + 1,
                        povrat: (this.povratInvesticije[i - 1].povrat + this.umanjena_god_usteda[i])
                    });
                }
            }
        },

        calcuateSumPot() {
            for (let i = 0; i < 15; i++) {
                this.ukupna_god_potrosnja_graf.push([
                    i + 1,
                    this.ukupna_god_potrosnja[i]
                ]);
            }
        },

        calculateRoaByYear() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.roa[i] = [
                        i + 1,
                        (this.umanjena_god_usteda[i] / this.pocetno_ulaganje) * 100
                    ]
                } else {
                    if (this.ulaganje_imovina[i - 1] === 0) {
                        this.roa[i] = [
                            i + 1,
                            0
                        ]
                    } else {
                        this.roa[i] = [
                            i + 1,
                            (this.umanjena_god_usteda[i] / this.ulaganje_imovina[i - 1]) * 100
                        ]
                    }
                }
            }
        },

        clearForm() {
            this.iskoristivaPovKrova = null;
            this.zakSnagaObjekta = null;
            this.godSmanjenjePotrosnje = null;
            this.udioFNE = null;
            this.godPotrosnja = null;

            this.elAuto = null;
            this.elBicikla = null;

            this.subvencija = null;
            this.iznos_kredita = null;
            this.kam_stopa = null;
            this.rok_otplate = null;
            this.amort_razd = null;

            //vrijednosti provjera povrsine krova
            this.potrebnaPovPokW = 6;
            this.faktor_iskoristivosti = 0.9;
            this.mogucna_snaga_FNE = null;

            //izracun snage FNE
            this.smanjenjePotrosnje = null;
            this.ocek_god_pot = 1000;
            this.faktor_proizvodnje = 0.9;
            this.snaga_FNE = null;
            this.plan_god_pro = null;
            this.potrebnaPovKrova = null;
            this.potreban_dokup_snage = null;

            //početno ulaganje
            this.cijena_oprema = null;
            this.cijena_dokup = null;
            this.pocetno_ulaganje = null;
            this.pocetno_ulag_PDV = null;
            this.pocetno_ulaganje_bruto = null;
            this.god_amortizacija = null;

            //izvori financiranja i kredit
            this.anuitet = 0;
            this.iznos_kamate_god = [];
            this.iznos_kvota = [];
            this.ostatak_duga = [];

            //ekonomski i novčani tok
            this.ukupna_god_potrosnja = [];
            this.planirana_god_potrosnja = null;
            this.troskoviOpskrbNeto = [];
            this.troskoviOpskrbBruto = [];
            this.prihodFNE_god_usteda = [];
            this.razlikaZaNaplatu = [];
            this.odrzavanje = 300;
            this.fin_rashodi = [];
            this.umanjena_god_usteda = [];
            this.umanjena_god_usteda_PDV = [];
            this.umanjena_god_usteda_bruto = [];

            this.ekonomicnost = [];
            this.EBIT = [];
            this.EBITDA = [];
            this.brutoProfMrez = [];
            this.netoProfMrez = [];
            this.ulaganje_imovina = [];
            this.dug = [];
            this.roa = [];
            this.povrat = [];
            this.nnt = [];
            this.dostatnostNNT = [];

            this.povratInvesticije = [];

            this.doneCalculate = false;

        }
    },
    watch: {
        odabranaSub() {
            this.pocetniTroskovi();
            this.subvencijaIzracun();
        },
    }
};
</script>
